import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- constants
import ApiConstants from 'PMT/constants/ApiConstants';
import ViewConstants from 'constants/ViewConstants';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMultipart from 'PMT/entities/RestaurantMultipart';

import { CurrencyUtils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';

// -- views
import RestaurantFormComponent from './RestaurantFormComponent';
import {
  POSChooser,
  ImageDropzone,
  TextInput,
  SimplePhoneInput,
  EmailInput,
  BitfieldChooser,
  NumberInput
} from 'PMT/components/form';
import Switch from 'react-bootstrap-switch';

export default class AdminFormView extends RestaurantFormComponent {

  static propTypes = {
    restaurant: PropTypes.instanceOf(Restaurant),

    /**
    * @param RestaurantMultipart
    */
    onUpdate: PropTypes.func.isRequired
  };

  state = this.getDefaultState(this.props.restaurant);

  //
  // RestaurantFormComponent override.
  //

  getDefaultState(restaurant: Restaurant) {
    return {
      features: restaurant.features,
    };
  }

  haveModifications() {
    const restaurant:Restaurant = this.props.restaurant;
    const state = this.state;

    return !(state.features === restaurant.features
    );
  }

  //
  // form actions
  //

  onFeaturesChange = (features) => {
    this.setState({
      features
    });
  };

  //
  // submit
  //

  onSubmit = (event) => {
    event.preventDefault();

    const restaurantMultipart: RestaurantMultipart = new RestaurantMultipart();

    restaurantMultipart.features = this.state.features;

    this.props.onUpdate(restaurantMultipart);
  };

  //
  // renderers
  //

  renderFeatures() {
    const options = [
      {
        label: I18n.tr('restaurant_edit.features.payment'),
        value: 1
      },
      {
        label: I18n.tr('restaurant_edit.features.order'),
        value: 2
      },
    ];

    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>
            {I18n.tr('restaurant_edit.features.label')}
          </label>
        </div>

        <div className="col-xs-6">
          <BitfieldChooser
            options={options}
            mask={this.state.features}
            onChange={this.onFeaturesChange}
            readOnly={!SecurityContext.restaurantSettings.editFeatures()}
          />
        </div>
      </div>
    );
  }

  render() {
    const restaurant: Restaurant = this.props.restaurant;

    return (
      <div className="edit_restaurant_form_view__private">
        <form className="form-horizontal">

          <div>
            {this.renderFeatures()}
            <hr />
          </div>

          {this.renderButtons()}
        </form>

      </div>
    );
  }

}
